var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"rules":_vm.rules,"name":"name","label":!_vm.$attrs.placeholder ? 'Nome' : '',"autocomplete":"name"}},'v-text-field',[_vm.fieldProps, _vm.$attrs],false))}
var staticRenderFns = []

export { render, staticRenderFns }